import script from "./QrCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./QrCode.vue?vue&type=script&setup=true&lang=ts"

import "./QrCode.vue?vue&type=style&index=0&id=05ee8f69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ee8f69"]])

export default __exports__